import React from 'react';
import {connect} from 'react-redux';
import { parse, isSameDay, format, addMinutes} from 'date-fns';
import {IconChevron, IconPedestrian} from '../Icons';
import TripLeg from './TripLeg';
import TransitBadge from './TransitBadge';
import TripWarnings from './TripWarnings';
import { durationInWords } from '../../utils/directionsUtilities';

const Itinerary = props => {
    const {trip,label,isOpen,handleClick} = props;
    const accordionClass = isOpen ? 'otp-accordion-section open' : 'otp-accordion-section';
    const ariaLabel = isOpen ? 'Close trip detail panel' : 'Open trip detail panel';
    const requestStart = parse(props.requestDate);
    const agencyOffset = (trip.legs[0].agencyTimeZoneOffset) / (60 * 1000);
    const today = new Date();
    const timezoneDiff = agencyOffset + today.getTimezoneOffset();
    const tripStart = addMinutes(parse(trip.startTime), timezoneDiff);
    const tripEnd = addMinutes(parse(trip.endTime), timezoneDiff);
 

    return(
        <div className={accordionClass}>
            <button
                className="otp-accordion-header"
                id={`otp-accordion-header-${label}`}
                onClick={handleClick}
                aria-controls={`otp-accordion-panel-${label}`}
                aria-expanded={isOpen}
                aria-label={ariaLabel}
            >
                <div className="otp-trip-label">
                    {label}
                </div>
                <div className="otp-trip-summary">
                    <div className="otp-trip-details">
                        <div>
                            <span className="otp-trip-time">
                                {format(tripStart, 'h:mm a')} - {format(tripEnd, 'h:mm a')}
                            </span>
                            <TripWarnings trip={trip} />
                        </div>
                        <div className="otp-trip-icons">
                            {trip.legs.map(leg => {
                                if (leg.interlineWithPreviousLeg) {
                                    return;
                                }
                                const key = leg.startTime.toString() + leg.duration.toString();
                                return (
                                    <div
                                        className="otp-icon-wrapper"
                                        key={key}
                                    >
                                        { getTripLegIcon(leg) }
                                    </div>);
                            })}
                        </div>
                    </div>
                    <div className="otp-trip-duration">
                        {durationInWords(trip.duration)}
                    </div>
                    <div className="otp-accordion-icon">
                        <IconChevron />
                    </div>
                </div>
            </button>
            <div
                className="otp-accordion-panel"
                id={`otp-accordion-panel-${label}`}
            >

                {!isSameDay(tripStart, requestStart) &&
                    <div className="otp-directions-caption">Trip Date: {format(tripStart, 'dddd, MMMM Do')}</div>
                }
                {trip.legs.map((leg, idx) => {
                    const key = leg.duration.toString() + leg.startTime.toString();
                    console.log('leg ' , leg);

                    return (<TripLeg details={leg} key={key} idx={idx} />);
                })}
            </div>
        </div>
    );
};

const getTripLegIcon = leg => {
    if (leg.mode === 'WALK') {
        return <div className="otp-trip-icon"><IconPedestrian /></div>;
    } else {
        return <TransitBadge leg={leg} />;
    }
};

const mapStateToProps = state => {
    return {
        requestDate: state.form.fields.date.value
    };
};

export default connect(mapStateToProps)(Itinerary);